import store from '@/modules/store';

export default {
  // Requires the user to have access to manage settings
  canManageBilling(to, from, next) {
    if (store.state.user && store.state.user.canManageBilling) {
      return next();
    }

    next('/');
  },

  // Requires the user to have access to manage settings
  canManageSettings(to, from, next) {
    if (store.state.user && store.state.user.canManageSettings) {
      return next();
    }

    next('/');
  },

  // Requires the user to be authenticated
  mustBeAuthenticated(to, from, next) {
    if (store.state.user) {
      return next();
    }

    if (to.fullPath === '/') {
      next('/login');
    } else {
      next(`/login?to=${encodeURIComponent(to.fullPath)}`);
    }
  },

  // Requires the user to be an admin
  mustBeAdmin(to, from, next) {
    if (store.state.user && store.state.user.isAdmin) {
      return next();
    }

    next('/');
  },

  // Requires the user to be a superuser
  mustBeSuperuser(to, from, next) {
    if (store.state.user && store.state.user.isSuperuser) {
      return next();
    }

    next('/');
  },

  // Requires the user to have a business or agency plan
  mustBeBusiness(to, from, next) {
    if (store.state.user && ['business', 'agency'].includes(store.state.user.account.plan)) {
      return next();
    }

    next('/');
  },

  // Requires the user to have a business or better plan
  mustBeAgency(to, from, next) {
    if (store.state.user && store.state.user.account.plan === 'agency') {
      return next();
    }

    next('/');
  },

  // Logs the user out before serving the router
  mustNotBeAuthenticated(to, from, next) {
    if (store.state.user && store.state.user.isAuthenticated) {
      return next('/');
    }

    next();
  }
};
